// extracted by mini-css-extract-plugin
export default {"main__03":"OrderSummary_main__03__ha5PW"};